import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  BsRocketTakeoff,
  BsPatchCheck,
  BsTrophy,
  BsBriefcase,
  BsStars,
  BsCodeSquare,
  BsFolder2Open,
  BsBullseye,
  BsPencilSquare,
  BsCheck2Circle,
  BsMegaphone,
  BsCalendar3
} from "react-icons/bs";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import trophyExactImg from "../../assets/images/trophy_exact.jpg";
import "./BuildXChallengePopup.css";

const BuildXChallengePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    const handleOpenModal = () => setShowModal(true);
    window.addEventListener("openBuildXAbout", handleOpenModal);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("openBuildXAbout", handleOpenModal);
    };
  }, []);

  const handleJoinNow = () => {
    setShowModal(true);
  };

  const handleLetsGo = () => {
    setShowModal(false);
    navigate("/buildx-challenge");
  };

  const location = useLocation();
  if (location.pathname === "/buildx-challenge") return null;

  return (
    <>
      {/* <AnimatePresence>
        {isVisible && (
          <motion.div
            className="build-x-popup-container"
            initial={{ opacity: 0, scale: 0.8, x: 50, y: 50 }}
            animate={{ opacity: 1, scale: 1, x: 0, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, x: 50, y: 50 }}
            transition={{ type: "spring", stiffness: 100, damping: 15 }}
          >
            <motion.div
              className="build-x-card"
              animate={{
                y: [0, -15, 0],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              <img src={trophyExactImg} alt="Build X Challenge" className="trophy-bg-img" />

              <div className="build-x-overlay">
                <motion.h3
                  className="build-x-label"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8, duration: 0.6 }}
                >
                  BUILD X CHALLENGE PROGRAM 2026
                </motion.h3>

                <motion.button
                  className="build-x-btn"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleJoinNow}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 1.1, duration: 0.6 }}
                >
                  Join Now
                </motion.button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence> */}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="build-x-about-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>About the program</Modal.Title>
        </Modal.Header>
        <Modal.Body className="about-modal-body-with-bg">
          <div className="about-content-overlay">
            <p className="about-intro">
              We are conducting this program especially for college studying students to bridge the gap between
              academic learning and industry excellence. The <strong>BUILD X CHALLENGE 2026</strong> is designed
              to identify and nurture the next generation of tech leaders.
            </p>

            <ul className="benefit-list">
              <li><span className="benefit-icon"><BsRocketTakeoff /></span> Real-time live project experience</li>
              <li><span className="benefit-icon"><BsPatchCheck /></span> Valuable participation certificate for your resume</li>
              <li><span className="benefit-icon"><BsTrophy /></span> Winner certificate with recognition</li>
              <li><span className="benefit-icon"><BsBriefcase /></span> Internship opportunity for top performers</li>
              <li><span className="benefit-icon"><BsStars /></span> Get featured on Zentexus website</li>
              <li><span className="benefit-icon"><BsCodeSquare /></span> Improve your coding and problem-solving skills</li>
              <li><span className="benefit-icon"><BsFolder2Open /></span> Strengthen your portfolio with a live project</li>
              <li><span className="benefit-icon"><BsBullseye /></span> Experience real industry workflow</li>
            </ul>

            <h5 className="about-subtitle mt-4"><BsCalendar3 /> Important Dates</h5>
            <ul className="timeline-list">
              <li>
                <span className="timeline-icon"><BsPencilSquare /></span>
                <span className="date-label">Registration Open</span>
                <span className="date-pill">April 30 - May 6</span>

              </li>
              <li>
                <span className="timeline-icon"><BsRocketTakeoff /></span>
                <span className="date-label">Task Release</span>
                <span className="date-pill">May 9</span>

              </li>
              <li>
                <span className="timeline-icon"><BsCheck2Circle /></span>
                <span className="date-label">Submission Deadline</span>
                <span className="date-pill">May 23</span>

              </li>
              <li>
                <span className="timeline-icon"><BsMegaphone /></span>
                <span className="date-label">Result Announcement</span>
                <span className="date-pill">May 31</span>

              </li>
            </ul>

            <p className="about-footer-note mt-4">
              Join us in this journey to innovate and build in the digital era.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button className="lets-go-btn" onClick={handleLetsGo}>
              Let's Go
            </Button>
          </motion.div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BuildXChallengePopup;
